module.exports = __webpack_public_path__ + "img/tra_bg_pro2@2x.dbdf464c.png";